<nav class="navbar navbar-expand-lg navbar-dark nav-oaj sticky-top">
  <div class="container">
    <a class="navbar-brand d-flex align-items-center gap-3">
      <img class="brand-logo" src="assets/img/logotipoOAJ_horizontal_blanco.png"
        alt="Órgano de Administración Judicial">
    </a>
  </div>

</nav>


<!-- Hero -->
<header class="hero-wrap">
  <div class="container ">
    <div class="row align-items-center g-4">
      <div class="col-lg-6 aos-init aos-animate" data-aos="fade-right">
        <!--
          <div class="d-inline-flex align-items-center gap-2 mb-3">
            <img class="logoOAJ" src="assets/img/logotipoOAJ_horizontal_negro.png" alt="Órgano de Administración Judicial">
          </div>
          -->
        <h1 class="display-5 fw-bold hero-title mb-3">
          Plataforma de Interconexión con Autoridades
        </h1>
        <p class="mb-3 inicio" style="color: rgba(0,0,0,.75); line-height: 1.6;">
          La Plataforma de Interconexión con Autoridades, es el sistema tecnológico que permite a las autoridades el
          acceso en línea a los Juzgados de Distrito y Tribunales de Circuito en toda la República Mexicana, con el
          objetivo de poder practicar notificaciones vía electrónica, permitir el envío/recepción de cualquier promoción
          o demanda electrónica, así como la consulta de los expedientes electrónicos respectivos, en la que los
          documentos gocen de plena validez al incorporar firmas electrónicas.
        </p>

      </div>

      <div class="col-lg-6 text-center aos-init aos-animate" data-aos="fade-left">
        <!--INICIO LOGIN-->
        <div id="seccion-login-personalizada">
          <div class="card-body tarjeta-acceso">
            @if(error){
            <div class="alert alert-danger py-2" role="alert">
              {{ error }}
            </div>
            }
            <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" novalidate>
              <div class="tituloLogincaja mb-2">
                <img class="icnTop" src="assets/img/userLog.svg" alt="Logo">
                <h3 class="titulo-login">Acceso a Interconexión</h3>
              </div>


              <div class="form-group  mb-3"><!--Usuario-->
                <label for="username" class="form-label">Usuario</label>

                <div class="contenedor-input">
                  <img class="icnLog" src="assets/img/userLog.svg" alt="Logo">
                  <input id="username" type="text" class="entrada-texto form-control" formControlName="username"
                    placeholder="Correo electrónico"
                    [class.is-invalid]="loginForm.get('username')?.invalid && loginForm.get('username')?.touched"
                    required />
                  @if(loginForm.get('username')?.errors && loginForm.get('username')?.touched){
                  <div class="invalid-feedback">
                    @if(loginForm.get('username')?.hasError('required')){
                    <span>El usuario es requerido</span>
                    }

                  </div>

                  }

                </div>
                <span class="label-Custom">Ingresar la cuenta de correo electrónico institucional de la
                  autoridad.</span>
              </div><!--Usuario-->

              <div class="form-group mb-3">
                <label for="password" class="form-label">Contraseña</label>
                <div class="contenedor-input">
                  <img class="icnLog" src="assets/img/llave.svg" alt="Logo">
                  <input id="password" [type]="fieldTextType ? 'text' : 'password'" class="entrada-texto form-control"
                    formControlName="password" placeholder="Contraseña"
                    [class.is-invalid]="loginForm.get('password')?.invalid && loginForm.get('password')?.touched"
                    required autocomplete="on" />
                  <div tabindex="0" class="input-group-append" (click)="toggleFieldTextType()"
                    (keypress.enter)="toggleFieldTextType()">
                    @if(!fieldTextType){
                    <span class="input-group-text">
                      <i class="fa fa-eye-slash"></i>
                    </span>
                    }
                    @if(fieldTextType){
                    <span class="input-group-text">
                      <i class="fa fa-eye"></i>
                    </span>
                    }


                  </div>
                  @if(loginForm.get('password')?.errors && loginForm.get('password')?.touched){
                  <div class="invalid-feedback">
                    @if(loginForm.get('password')?.hasError('required')){
                    <span>La contraseña es
                      requerida.</span>
                    }
                    @if(loginForm.get('password')?.hasError('minlength')){
                    <span>Mínimo 8 caracteres.</span>
                    }
                  </div>
                  }

                </div>
                <div class="enlaces-adicionales">
                  <a href="#/reestablecerPass">Reestablecer contraseña</a>
                </div>

                <div class="enlaces-adicionales">
                  <!--  ¿Desea dar de alta a la autoridad que representa para uso de la Plataforma Interconexión con
                  Instituciones Públicas? Dar clic <a href="#" (click)="openModal(contentAutoEnrolamiento)">aquí</a> -->
                  ¿Desea dar de alta a la autoridad que representa para uso de la Plataforma de Interconexión con
                  Autoridades? Dar clic <a href="#" (click)="openModal(contentAutoEnrolamiento)">aquí</a>
                </div>

              </div>

              <div class="d-grid">
                @if(errorMessage){

                <div
                  [ngClass]="{ 'alert': errorMessage, 'alert-success': TypeMessage === 'success', 'alert-danger': TypeMessage === 'error','alert-warning':TypeMessage === 'warning' }">
                  {{errorMessage}}
                </div>
                }

                <div>
                  @if (captchaValido === false) {
                  <cjf-textual #captchaComponent (respuesta)="respuestaCaptcha($event)"></cjf-textual>
                  }
                  @else {
                  <div class="alert alert-success" role="alert">
                    <span>Captcha validado</span>
                  </div>
                  }
                </div>
                <button type="submit" class="boton-enviar" [disabled]="loginForm.invalid || loading">
                  @if(!loading){
                  <span>Entrar</span>
                  }
                  @if(loading){
                  <span class="d-flex align-items-center justify-content-center">
                    <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    Iniciando...
                  </span>
                  }

                </button>
              </div>
            </form>

          </div>
        </div><!--FIN LOGIN-->
      </div>
    </div>
  </div>

  <!-- Quick Actions (cards like the PDF) -->

</header>

<!-- Sections -->
<main class="py-01">
  <section id="info" class="section-pad-sm">
    <div class="container-fluid tarjetasCont">

      <div class="row g-4 mb-5">
        <div class="col-lg-3 aos-init" data-aos="fade-up">
          <div class="glass-card p-3 p-md-3 h-100">
            <h3 class="h5 fw-bold mb-3 tituloCardLog">¿Qué es la Interconexión Digital?</h3>
            <ul class="checklist mb-0 txtQuees">
              La interconexión digital es un mecanismo de integración tecnológica estructurada, segura y trazable entre
              el Órgano de Administración Judicial del Poder Judicial de la Federación y las autoridades del Estado
              mexicano
            </ul>
            <button class="boton-LOGIN" type="submit" (click)="navegarAlSitio()">Ingresar a micrositio
              informativo</button>
          </div>
        </div>

        <!--  <div class="col-lg-3 aos-init" data-aos="fade-up" data-aos-delay="50">
            <div class="glass-card p-3 p-md-3 h-100">
              <h3 class="h5 fw-bold mb-3 tituloCardLog">Checklist de uso</h3>
              <ul class="checklist mb-0">
                <li><img class="icnLog" src="assets/img/checked.svg" alt="Logo" > Verificar conexión estable a internet</li>
                <li><img class="icnLog" src="assets/img/checked.svg" alt="Logo" > Confirmar que el navegador esté actualizado</li>
                <li><img class="icnLog" src="assets/img/checked.svg" alt="Logo" > Borrar caché y cookies</li>
              </ul>
            </div>
          </div> -->

        <div class="col-lg-3 aos-init" data-aos="fade-up" data-aos-delay="50">

          <div class="glass-card p-3 p-md-3 h-100">
            <h3 class="h5 fw-bold mb-3 tituloCardLog">¿Cómo dar de alta en línea a las autoridades en la Plataforma de
              Interconexión?
            </h3>
            <ul class="checklist mb-0">
              <button class="boton-LOGIN" type="submit" (click)="navegarAlSitioOpc(2)"><i class="fas fa-download"></i>
                Descargar guía</button>
            </ul>
            <h3 class="h5 fw-bold mb-3 tituloCardLog">¿Cómo ingresar a la Plataforma de Interconexión con Autoridades?
            </h3>
            <ul class="checklist mb-0">
              <button class="boton-LOGIN" type="submit" (click)="navegarAlSitioOpc(1)"><i class="fas fa-download"></i>
                Descargar guía</button>
            </ul>
          </div>
        </div>

        <div class="col-lg-3 aos-init" data-aos="fade-up" data-aos-delay="50">
          <div class="glass-card p-3 p-md-3 h-100">
            <h3 class="h5 fw-bold mb-3 tituloCardLog">¿Problemas para ingresar?</h3>
            <ul class="checklist mb-0">
              <li><img class="icnLog" src="assets/img/checked.svg" alt="Logo"> Confirmar que el usuario esté escrito
                correctamente (considerando mayúsculas, minúsculas y sin espacios antes o después)</li>
              <li><img class="icnLog" src="assets/img/checked.svg" alt="Logo"> Verificar que la tecla Bloq Mayús no esté
                activada</li>
              <li><img class="icnLog" src="assets/img/checked.svg" alt="Logo"> Revisar que el teclado esté en el idioma
                correcto</li>
              <li><img class="icnLog" src="assets/img/checked.svg" alt="Logo"> Verificar conexión estable a internet
              </li>
              <li><img class="icnLog" src="assets/img/checked.svg" alt="Logo"> Confirmar que el navegador esté
                actualizado</li>
              <li><img class="icnLog" src="assets/img/checked.svg" alt="Logo"> Borrar caché y cookies</li>
            </ul>
          </div>
        </div>

        <div class="col-lg-3 aos-init" data-aos="fade-up" data-aos-delay="50">
          <div class="glass-card p-3 p-md-3 h-100">
            <h3 class="h5 fw-bold mb-3 tituloCardLog">Datos de contacto
            </h3>
            <ul class="checklist mb-0">
              <li>Contáctenos a través de nuestros teléfonos o correo electrónico de soporte:</li>
              <div class="correoCard"><img class="icnLogMail" src="assets/img/mail.svg"
                  alt="Logo">dggj.interconexion@oaj.gob.mx</div>
              <div class="correoCard"><img class="icnLogMail" src="assets/img/phone.svg" alt="Logo">
                (55) 5490 8500 <br> Extensiones: 1366, 1635, 1671, 2402, 2404, 2410, 2413, 2414, 2419, 2421 y 8323
              </div>
            </ul>
          </div>
        </div>

      </div>
    </div>
  </section>
</main>

<ng-template #contentAutoEnrolamiento let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Requisitos para Autoenrolamiento</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body">
    <form>
      <div class="mb-3">
        <p>
          Para solicitar en línea el alta de la autoridad que representa para uso de la Plataforma de Interconexión con
          Autoridades, deberá contar con la siguiente información y documentación para poder realizar el
          envío de la
          solicitud:
        </p>
        <ul>
          <li>Denominación de su dependencia</li>
          <li>Denominación de la Autoridad específica a dar de alta</li>
          <li>Nombre completo de la persona servidora pública que está realizando la solicitud para dar de alta a la
            Autoridad
            en la plataforma</li>
          <li>Datos de contacto:</li>
          <ul>
            <li>Correo electrónico oficial de la autoridad en el cual pueda recibir comunicaciones administrativas de la
              plataforma, como por ejemplo, verificación de la cuenta y cambio de contraseña. Nota: el sistema aceptará
              diversos
              dominios, tanto institucionales como comerciales, sin embargo, es importante que se considere que la
              cuenta esté
              asociada a la autoridad que se dará de alta y no a la cuenta personal de un servidor público.</li>
            <li>Correo electrónico institucional de la persona servidora pública que está realizando el trámite, en el
              cual se
              pueda establecer contacto en caso de alguna duda con el registro de alta solicitado.</li>
            <li>Número de teléfono institucional de la persona servidora pública que está realizando el trámite, en el
              cual se
              pueda establecer contacto en caso de alguna duda con el registro de alta solicitado.</li>
          </ul>
          <li>Documentación: En el proceso de registro se solicitará que ingrese los siguientes documentos, ya sea
            conformando
            un solo archivo o en varios.</li>
          <ul>
            <li>Nombramiento</li>
            <li>Identificación</li>
            <li>Oficio de autorización de la persona servidora pública autorizada para realizar la solicitud de alta a
              la
              Autoridad en la plataforma.</li>
          </ul>
          <li>Contar con cualquiera de las firmas electrónicas aceptadas FIREL, FIRMA.JUDICIAL, E.FIRMA, FEJEM, FIREC o
            FELAVA
          </li>
        </ul>
        <p>
          Si cuenta con dichos requisitos, puede continuar con el trámite dando clic <a href="#/autoEnrolamiento"
            (click)="modal.close('Save click')">aquí</a>.
        </p>
      </div>
    </form>
  </div>
  <!-- <div class="modal-footer">
		<button type="button" class="btn btn-outline-secondary" (click)="modal.close('Save click')">Save</button>
	</div> -->
</ng-template>
<!-- @if(MostrarOrganos){
<oaj-organos-itx (AccederICOIJ)="AccederOrgSel($event)"></oaj-organos-itx>
}
 -->